import { supabase } from '@/lib/supabase';

export type CreateTrackingRequestProps = {
  projectId: number;
  orgId: number;
};

export const createTrackingRequest = async ({
  projectId,
}: CreateTrackingRequestProps) => {
  const { data, error } = await supabase.rpc('request_tracking', {
    p_client_project_id: projectId,
  });

  if (error) throw error;

  return data;
};
